import { Flex, Input, Popover, Tooltip, Radio } from "antd";
import { DeleteOutlined, HolderOutlined, EditOutlined, PlusOutlined, CaretUpFilled, DownOutlined, CaretDownFilled } from "@ant-design/icons";
import { useState } from "react";
import DraggableItem from "../Sprint/DraggableItem";
import { useTranslation } from 'react-i18next';


const ResourceItem = (props) => {
    const { t } = useTranslation();
    const { sprintDetail, resource, handleResourceSelection, deleteResource, removeTeam, editTeam, handleCountChange, costViewEnable=false } = props
    const [isOpen, setIsOpen] = useState(true)

    const handleContextMenu = (event) => {
        event.preventDefault(); // Prevent the default context menu from appearing
    };



    return (
        <div className="sprint-row resource-parent-row" style={{ flexDirection: "column" }}>
            <Flex>
                <div className="left-section-row-data delivery-unit-row">
                    <div className="add-sprint-item" style={{ gap: 12, alignItems: "center" }}>
                        <Flex gap={5} className="sprint-action">
                            <HolderOutlined className="app-icon" style={{ marginRight: "5px" }} />
                            <PlusOutlined className="app-icon" onClick={() => handleResourceSelection(resource.uuid)} />
                        </Flex>
                        <div className="sprint-input" style={{ height: "40px" }}>
                            {
                                isOpen ? <CaretUpFilled style={{ color: "#0A99FE", marginRight: "5px" }} onClick={() => setIsOpen(false)} /> : <CaretDownFilled style={{ color: "#0A99FE", marginRight: "5px" }} onClick={() => setIsOpen(true)} />
                            }{resource.deliveryUnit}
                        </div>
                        <DeleteOutlined className="app-icon delete-icon" onClick={() => deleteResource(resource.uuid)} />

                    </div>

                </div>
                <div className="add-sprint-item" style={{ display: "flex", width: "100%" }}>
                    {
                        [...Array(sprintDetail.duration)].map((e, i) => {
                            return <div className="week-block object-effort-block object-input" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <div style={{ height: "40px" }}></div>
                            </div>
                        })
                    }
                </div>

            </Flex>
            {
                resource.teams && isOpen ? <>
                    {
                        Object.keys(resource.teams).map((key, index) => {
                            let currentTeams = resource.teams[key]

                            return (
                                <>
                                    <Flex align="center" style={{ height: "36px" }}>
                                        <Flex className="team-row" gap={10}>
                                            <div className="sprint-action" style={{ width: "54px" }}></div>
                                            <div className="object-input" style={{ borderRadius: "0", fontWeight: "600" }}>{key}</div>
                                        </Flex>
                                        <div className="add-sprint-item" style={{ display: "flex", width: "100%" }}>
                                            {
                                                [...Array(sprintDetail.duration)].map((e, i) => {
                                                    return <div className="week-block object-effort-block object-input" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <div style={{ height: "40px" }}></div>
                                                    </div>

                                                })
                                            }
                                        </div>
                                    </Flex>
                                    {

                                        currentTeams.map(team => {
                                            return (
                                                <Flex align="center" className="skill-row">
                                                    <Flex gap={10} className="team-row">
                                                        <div className="sprint-action" style={{ width: "54px" }}></div>
                                                        {
                                                            team["Skill Level1"] && <Tooltip title={team["Skill Level1"]}>
                                                                <div className="skill-input">{team["Skill Level1"]}</div>
                                                            </Tooltip>
                                                        }
                                                        {
                                                            team["Skill Level2"] ? <Tooltip title={team["Skill Level2"]}>
                                                                <div className="skill-input">{team["Skill Level2"]}</div>
                                                            </Tooltip>
                                                                : <div className="skill-input"></div>
                                                        }
                                                        {
                                                            team["Employee Level"] ? <Tooltip title={team[key]}>
                                                                <div className="skill-input" style={{ width: "35px" }}>{team["Employee Level"]}</div>
                                                            </Tooltip>
                                                                : <div className="skill-input" style={{ width: "35px" }}></div>
                                                        }
                                                        <Flex gap={8} className="team-action" align="flex-start" style={{ paddingTop: "2px" }}>
                                                            <EditOutlined className="app-icon" onClick={() => editTeam(resource.uuid, key, team["uuid"])} />
                                                            <DeleteOutlined className="app-icon" onClick={() => removeTeam(key, index, resource.uuid)} />
                                                        </Flex>

                                                    </Flex>
                                                    <div className="add-sprint-item" style={{ display: "flex", width: "100%" }}>
                                                        {
                                                            [...Array(sprintDetail.duration)].map((e, i) => {
                                                                let currentDuration = Number(i + 1)
                                                                let currentSite = team.count[currentDuration]?.onSite || false
                                                                const content = (
                                                                    <div style={{ padding: "12px" }}>
                                                                        <Radio.Group value={currentSite} onChange={(e) => handleCountChange(team.uuid, key, resource.uuid, String(currentDuration), e.target.value, "onsite")}>
                                                                            <Radio style={{ display: "flex", marginBottom: "5px" }} value={true}>{t('Onsite')}</Radio>
                                                                            <Radio value={false}>{t('Offshore')}</Radio>
                                                                        </Radio.Group>
                                                                    </div>
                                                                );

                                                                return <div className="week-block object-effort-block object-input" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", position: "relative" }} onContextMenu={handleContextMenu}>
                                                                    <Popover content={content} trigger="contextMenu" title="">
                                                                        <div style={{ width: "100%" }} >
                                                                            {
                                                                                costViewEnable ? <div style={{width: "100%", textAlign: "center"}}>{team["count"]?.[currentDuration].cost}</div>
                                                                                : <Input style={{ textAlign: "center"}} value={team.count[currentDuration]?.resourceCount} onChange={(e) => handleCountChange(team.uuid, key, resource.uuid, String(currentDuration), e.target.value, "resourceCount")} />
                                                                            }
                                                                        </div>
                                                                    </Popover>
                                                                    {
                                                                        currentSite ? 
                                                                        <div className="site-block">
                                                                            <CaretDownFilled style={{color: "#141BCB", transform: "rotate(315deg)", fontSize: 18}} />
                                                                        </div>
                                                                        : null
                                                                    }
                                                                </div>

                                                            })
                                                        }
                                                    </div>
                                                </Flex>
                                            )
                                        })

                                    }
                                </>
                            )
                        })

                    }
                </>
                    : null
            }
        </div>
    )
}

export default ResourceItem